import React from "react";

const Planes = () => {
  return (
    <div className="container py-4">
      <h1 className="fw-bold mb-3">Planes disponibles</h1>
      <p className="text-secondary mb-4">
        Hoy tenemos un unico plan pensado para que un comercio empiece rapido.
      </p>

      <div className="border rounded p-4 bg-light text-dark" style={{ maxWidth: "430px" }}>
        <h3 className="fw-bold">Plan Unico</h3>
        <p className="mb-2">Crear y gestionar beneficios</p>
        <p className="mb-2">Reclamos y consumos con QR</p>
        <p className="mb-2">Resenas y puntuaciones</p>
        <p className="mb-2">Panel y metricas del negocio</p>
        <h4 className="fw-bold mt-3 mb-1">USD 10 / mes</h4>
        <p className="text-success fw-semibold mb-0">30 dias gratis al registrarte</p>
      </div>
    </div>
  );
};

export default Planes;
